/* eslint-disable */
import React from 'react'
import { useState, useEffect } from "react";
import { ACCESS_LEVEL, ASSETTYPE, CONTENT_DISTRIBUTION_RESPONSE_TYPE, CONTENT_TYPE, DIGISIGN_LOGTYPE, DOCUMENT_TYPE, EPG_IMPORT_FIELD_TYPE, EPG_FILE_TYPE, FREQUENCY_TYPE, GENDERS, getPublishReportConfig, IMPORT_EXPORT_ACTION, IMPORT_EXPORT_MODULES, IMPORT_EXPORT_STATUS, MEDIA_TRANSMISSION, MENUTYPE, MESSAGE_TYPE, MESSAGE_VARIANT, MODULE, OFFER_TYPE, ORIENTATION, PLATFORM_SIMULCAST_CHANNEL_CONFIG, PLAYLIST_STATUS, PRIORITY, PRODUCTS, PUBLISH_REPORT, STORAGE_DESTINATION, SYNOPSIS_TYPE, THEMES, TRANSMISSION_STATUS, VERSION_TYPE, VODTYPE, WEIGHTAGE_FREQUENCY_TYPE, WEIGHTAGE_TYPE, VALIDATION_LEVEL_TYPE, RELATIVE_DATE, SEGMENT_DETAILS_CREDIT_TYPE } from '../../../constant/constant';
import * as API from '../../../API/api'
import { GRID_COL_INDEX_ATTRIBUTE } from '@progress/kendo-react-grid';
import { useTableKeyboardNavigation } from '@progress/kendo-react-data-tools';
import { META_GENDERS, PROMOTIONS_CAMPAIGN_TYPES, PROMOTIONS_MEDIA_TYPE, PROMOTIONS_PLATFORM } from '../../../../modules/SocialMedia/SocialMediaConstant';

import {
  Cloud as CloudIcon,
  CloudDownload as CloudDownloadIcon,
  FolderShared as FolderSharedIcon,
  Shuffle as ShuffleIcon,
  Dns as DnsIcon,
  Storage as StorageIcon,
  Mail as MailIcon
} from "@mui/icons-material";

//key name and there enum
var foriegnKey = {
  OttAssetTypeSID: ASSETTYPE,
  MenuType: MENUTYPE,
  OttThemeSID: THEMES,
  moduleID: MODULE,
  frequencyType: FREQUENCY_TYPE,
  Products: PRODUCTS,
  DocumentType: DOCUMENT_TYPE,
  Status: PLAYLIST_STATUS,
  content_type: CONTENT_TYPE,
  orientation: ORIENTATION,
  accessLevel: ACCESS_LEVEL,
  MessageType: MESSAGE_TYPE,
  MessageVariant: MESSAGE_VARIANT,
  logType: DIGISIGN_LOGTYPE,
  genders: META_GENDERS,
  Type: SYNOPSIS_TYPE,
  ResponseType: CONTENT_DISTRIBUTION_RESPONSE_TYPE,
  Transmission: MEDIA_TRANSMISSION,
  VODType: VODTYPE,
  OfferType: OFFER_TYPE,
  Priority: PRIORITY,
  Platform: PLATFORM_SIMULCAST_CHANNEL_CONFIG,
  activeStatus: TRANSMISSION_STATUS,
  StorageDestination: STORAGE_DESTINATION,
  VersionType: VERSION_TYPE,
  Module: IMPORT_EXPORT_MODULES,
  FileProcessingStatus: IMPORT_EXPORT_STATUS,
  Action: IMPORT_EXPORT_ACTION,
  FrequencyType: WEIGHTAGE_FREQUENCY_TYPE,
  WeightageType: WEIGHTAGE_TYPE,
  Gender: GENDERS,
  TemplateModule: MODULE,
  EpgImportFieldType: EPG_IMPORT_FIELD_TYPE,
  ValidationLevel: VALIDATION_LEVEL_TYPE,
  RelativeStartDate: RELATIVE_DATE,
  SegmentDetailType: SEGMENT_DETAILS_CREDIT_TYPE,
  PromotionsMediaType: PROMOTIONS_MEDIA_TYPE,
  PromotionsPlatform: PROMOTIONS_PLATFORM,
  CampaignType: PROMOTIONS_CAMPAIGN_TYPES
}

const getIconForStorageDestination = (id) => {
  switch (id) {
    case STORAGE_DESTINATION.Cloudinary: return <CloudIcon sx={{ mr: 1, color: '#3448c5' }} />;
    case STORAGE_DESTINATION.S3: return <CloudIcon sx={{ mr: 1, color: '#FF9900' }} />;
    case STORAGE_DESTINATION.Download: return <CloudDownloadIcon sx={{ mr: 1, color: '#4caf50' }} />;
    case STORAGE_DESTINATION.SharedDirectory: return <FolderSharedIcon sx={{ mr: 1, color: '#9c27b0' }} />;
    case STORAGE_DESTINATION.SFTP:
    case STORAGE_DESTINATION.FTP: return <ShuffleIcon sx={{ mr: 1, color: '#00bcd4' }} />;
    case STORAGE_DESTINATION.Aspera: return <DnsIcon sx={{ mr: 1, color: '#ff5722' }} />;
    case STORAGE_DESTINATION.SMTP: return <MailIcon sx={{ mr: 1, color: '#e91e63' }} />;
    default: return <StorageIcon sx={{ mr: 1, color: '#607d8b' }} />;
  }
}

export const EnumCell = (props) => {

  const field = props.field || "";
  const fk_entityName = props.fk_entityName;
  const value = props.dataItem != undefined ? props.dataItem[field] : 1;
  const [displayValue, setdisplayValue] = useState("");

  useEffect(() => {
    loaddata();
  }, [props.dataItem])


  async function loaddata() {
    //TO SHOW Description,Name etc.. if only _id is saving in db
    if (field == 'publish_report_SID') {
      setdisplayValue(getPublishReportConfig(value).Description);
    } else if (!foriegnKey[field] && fk_entityName) {
      let masterRes = await API.getDataLookup(fk_entityName, { sort: { SID: 1 }, query: ['Archive', '=', false] });
      setdisplayValue(masterRes.data.find((x) => x._id == props.dataItem[field])[props?.format])
    } else if (!foriegnKey[field]) {
      let entityName = field.toLowerCase();
      let masterRes = await API.getDataLookup(entityName, { sort: { SID: 1 }, query: ['Archive', '=', false] });
      setdisplayValue(masterRes.data.find((x) => x._id == props.dataItem[field])[props?.format])
    } else {
      let arrayENUM = Object.keys(foriegnKey[field]).map((key) => { return { ID: foriegnKey[field][key], Description: key } })
      let filter = arrayENUM?.find((x) => x?.ID == value);
      setdisplayValue(filter?.Description ?? '');
    }

  }

  return <td
    colSpan={props.colSpan}
    role={"gridcell"}
    aria-colindex={props.ariaColumnIndex}
    aria-selected={props.isSelected}
    {...{
      [GRID_COL_INDEX_ATTRIBUTE]: props.columnIndex,
    }}
    {...useTableKeyboardNavigation(props.id)}
    // style={{textAlign : 'center'}}
    style={props.style}
  >
    {field == "StorageDestination" ? <div>{getIconForStorageDestination(value)}{displayValue}</div> : displayValue}
  </td>;
};

export const SIDEnumCell = (props) => {

  const { id, colSpan, ariaColumnIndex, isSelected, style, columnIndex, dataItem, field = "", fk_entityName, fk_field } = props;
  const value = (dataItem && field) ? dataItem[field] : null;

  if (!value) return <td></td>;

  const [displayValue, setdisplayValue] = useState("");

  useEffect(() => {
    loaddata();
  }, [dataItem])


  const loaddata = async () => {
    if (!fk_entityName) return;
    let res = await API.getDataLookup(fk_entityName, { query: ['SID', '=', value] });
    setdisplayValue(res?.data?.length > 0 ? res?.data[0][fk_field] : '');
  }

  return <td
    colSpan={colSpan}
    role={"gridcell"}
    aria-colindex={ariaColumnIndex}
    aria-selected={isSelected}
    {...{
      [GRID_COL_INDEX_ATTRIBUTE]: columnIndex,
    }}
    {...useTableKeyboardNavigation(id)}
    // style={{textAlign : 'center'}}
    style={style}
  >
    {displayValue}
  </td>;

}